import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromLandRegistry from '../_reducers/landRegistry';

export const selectLandRegistryState =
  createFeatureSelector<fromLandRegistry.LandRegistryState>('landRegistries');

export const selectAllLandRegistries = createSelector(
  selectLandRegistryState,
  fromLandRegistry.selectAll
);

export const selectLandRegistryEntities = createSelector(
  selectLandRegistryState,
  fromLandRegistry.selectEntities
);

export const selectLandRegistryById = (id: number) =>
  createSelector(selectLandRegistryEntities, (entities) => entities[id]);

export const selectLandRegistryTotal = createSelector(
  selectLandRegistryState,
  fromLandRegistry.selectTotal
);
